(function ($, window, document) {
  'use strict';

  if (!$ || !$.fn) {
    return;
  }

  var EVENT_NAMESPACE = '.cafetalesHome';

  function toBoolean(value) {
    return value === true || value === 'true';
  }

  function initHeroSliders(context) {
    var $context = context ? $(context) : $(document);
    var $sliders = $context.find('.js-cft-hero-slider');

    if (!$sliders.length || typeof $.fn.slick !== 'function') {
      return;
    }

    $sliders.each(function () {
      var $slider = $(this);

      if ($slider.hasClass('slick-initialized')) {
        return;
      }

      var slideCount = $slider.children('.cft-hero__slide').length;
      var initialSlide = parseInt($slider.attr('data-initial-slide'), 10) - 1;
      var autoplaySpeed = parseInt($slider.attr('data-autoplay-speed'), 10);

      if (Number.isNaN(initialSlide)) {
        initialSlide = 0;
      }

      if (Number.isNaN(autoplaySpeed)) {
        autoplaySpeed = 5000;
      }

      initialSlide = Math.max(0, Math.min(initialSlide, Math.max(0, slideCount - 1)));

      $slider.slick({
        accessibility: true,
        adaptiveHeight: false,
        arrows: false,
        autoplay: toBoolean($slider.attr('data-autoplay')) && slideCount > 1,
        autoplaySpeed: autoplaySpeed,
        centerMode: true,
        cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
        dots: false,
        draggable: true,
        initialSlide: initialSlide,
        infinite: slideCount > 1,
        pauseOnFocus: true,
        pauseOnHover: true,
        slidesToScroll: 1,
        slidesToShow: 1,
        speed: 700,
        swipe: true,
        touchMove: true,
        variableWidth: true
      });
    });
  }

  function destroyHeroSliders(context) {
    var $context = context ? $(context) : $(document);

    $context.find('.js-cft-hero-slider.slick-initialized').each(function () {
      $(this).slick('unslick');
    });
  }

  function activateRankingTab($tab, shouldFocus) {
    var $ranking = $tab.closest('.cft-ranking');
    var panelName = $tab.attr('data-panel');
    var $tabs = $ranking.find('.js-cft-ranking-tab');
    var $panels = $ranking.find('.js-cft-ranking-panel');

    if (!$ranking.length || !panelName) {
      return;
    }

    $tabs
      .removeClass('is-active')
      .attr({
        'aria-selected': 'false',
        'tabindex': '-1'
      });

    $tab
      .addClass('is-active')
      .attr({
        'aria-selected': 'true',
        'tabindex': '0'
      });

    $panels.attr('hidden', 'hidden');
    $panels.filter('[data-panel="' + panelName + '"]').removeAttr('hidden');

    if (shouldFocus) {
      $tab.trigger('focus');
    }
  }

  function bindRankingTabs() {
    $(document)
      .off('click' + EVENT_NAMESPACE, '.js-cft-ranking-tab')
      .on('click' + EVENT_NAMESPACE, '.js-cft-ranking-tab', function () {
        activateRankingTab($(this), false);
      });

    $(document)
      .off('keydown' + EVENT_NAMESPACE, '.js-cft-ranking-tab')
      .on('keydown' + EVENT_NAMESPACE, '.js-cft-ranking-tab', function (event) {
        var $tabs = $(this).closest('.cft-ranking__tabs').find('.js-cft-ranking-tab');
        var currentIndex = $tabs.index(this);
        var nextIndex = currentIndex;

        switch (event.key) {
          case 'ArrowLeft':
          case 'ArrowUp':
            nextIndex = currentIndex <= 0 ? $tabs.length - 1 : currentIndex - 1;
            break;
          case 'ArrowRight':
          case 'ArrowDown':
            nextIndex = currentIndex >= $tabs.length - 1 ? 0 : currentIndex + 1;
            break;
          case 'Home':
            nextIndex = 0;
            break;
          case 'End':
            nextIndex = $tabs.length - 1;
            break;
          default:
            return;
        }

        event.preventDefault();
        activateRankingTab($tabs.eq(nextIndex), true);
      });
  }

  function init(context) {
    initHeroSliders(context);
  }

  $(function () {
    bindRankingTabs();
    init(document);
  });

  $(document)
    .off('shopify:section:load' + EVENT_NAMESPACE)
    .on('shopify:section:load' + EVENT_NAMESPACE, function (event) {
      init(event.target);
    });

  $(document)
    .off('shopify:section:unload' + EVENT_NAMESPACE)
    .on('shopify:section:unload' + EVENT_NAMESPACE, function (event) {
      destroyHeroSliders(event.target);
    });

  $(document)
    .off('shopify:block:select' + EVENT_NAMESPACE)
    .on('shopify:block:select' + EVENT_NAMESPACE, function (event) {
      var $slide = $(event.target).closest('.cft-hero__slide');
      var $slider = $slide.closest('.js-cft-hero-slider');

      if ($slider.hasClass('slick-initialized') && $slide.length) {
        $slider.slick('slickGoTo', $slide.attr('data-slick-index') || $slide.index(), true);
        $slider.slick('slickPause');
      }
    });

})(window.jQuery, window, document);
